import googleAttachmentApi from "@apis/google.attachment.api";

export default class GoogleAttachmentService {
  constructor(context) {
    this.context = context;
  }

  create(data, toBePublished) {
    return new Promise((resolve, reject) => {
      const requestData = {
        lessonId: this.context.lessonId,
        sourceDocumentId: data.documentId,
        sourceDocumentTitle: data.title,
        sourceDocumentType: data.mimeType,
        toBePublished: toBePublished,
      };
      googleAttachmentApi.createGoogleAttachment(requestData).then(
        //OK
        (response) => {
          if (response.code === "error") {
            reject(response);
          }
          resolve(response.data);
        },
        (response) => {
          reject(response);
        },
      );
    });
  }

  createInStudentAttempt(data, withinSLS) {
    return new Promise((resolve, reject) => {
      const requestData = {
        lessonId: this.context.lessonId,
        sourceDocumentId: data.documentId,
        sourceDocumentTitle: data.title,
        sourceDocumentType: data.mimeType,
        toBePublished: false,
        withinSLS: withinSLS,
        teamId: data.teamId,
      };

      if (this.context.attemptContext) {
        requestData.attemptableUuid = this.context.attemptContext.attemptableUuid;
        requestData.attemptableType = this.context.attemptContext.attemptableType;
      }

      googleAttachmentApi.createGoogleAttachmentInStudentAttempt(requestData).then(
        //OK
        (response) => {
          if (response.code === "error") {
            reject(response);
          }
          resolve(response.data);
        },
        (response) => {
          reject(response);
        },
      );
    });
  }

  createInNotebook(data, toBePublished) {
    return new Promise((resolve, reject) => {
      const requestData = {
        lessonId: this.context.notebookId, // TODO: [Google] to rename lessonUuid to generic field
        sourceDocumentId: data.documentId,
        sourceDocumentTitle: data.title,
        sourceDocumentType: data.mimeType,
        toBePublished: toBePublished,
      };

      googleAttachmentApi.createGoogleAttachmentInNotebook(requestData).then(
        //OK
        (response) => {
          if (response.code === "error") {
            reject(response);
          }
          resolve(response.data);
        },
        (response) => {
          reject(response);
        },
      );
    });
  }
}
